/**
 * The Inventory Audit page's Help button and the pop-up it opens. Sits beside
 * Download in the page header; styled to match WorklistDownloadButton
 * (WorklistDownloadButton.tsx:82-96) so the two read as one control cluster.
 */
import React, { useCallback, useRef, useState } from "react"
import { HelpCircle } from "lucide-react"

import { THEME } from "../../config/theme"
import AuditHelpModal from "./AuditHelpModal"

export default function AuditHelpButton() {
  const [open, setOpen] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)

  // Stable across renders: the pop-up re-binds its Escape listener whenever
  // this changes. Focus returns to the button the pop-up was opened from.
  const close = useCallback(() => {
    setOpen(false)
    buttonRef.current?.focus()
  }, [])

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        title="What the colors, severities and tags on this page mean"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "7px 14px",
          fontSize: 13,
          fontWeight: 500,
          fontFamily: THEME.fonts.primary,
          borderRadius: THEME.borderRadius.sm,
          border: `1px solid ${THEME.colors.silver}`,
          background: THEME.colors.white,
          color: THEME.colors.neutral.light.textPrimary,
          cursor: "pointer",
        }}
      >
        <HelpCircle size={15} />
        Help
      </button>
      {open && <AuditHelpModal onClose={close} />}
    </>
  )
}
